import logo from "./logo.png";
import reedem from "./Reedem.png";
import revenue from "./Revenue.png";
import service from "./Service.png";
import users from "./Users.png";
import background from "./background.png";
import show from "./show.png";
import hide from "./hide.png";
import dashboard from "./dashboard.png";
import home from "./home.png";
import user from "./user.png";
import showcase from "./showcase.png";
import settings from "./settings.png";
import role from "./role.png";
import market from "./market.png";
import content from "./content.png";
import customer from "./customer.png";
import logout from "./logout.png";
import demouser from "./demo-user.png";
import see from "./see.png";
import change from "./change.png";
import remove from "./remove.png";
import search from "./search.png"
import oratricslogo from './oratricslogo.png'
import bright from './brightchamps_kid.webp'

import trophy from "./trophy.jpg"
import trophyone from "./trophyone.jpg"

import portrait from "./portrait.png"
// import cover from "./cover_img.svg"
import gamer from "./gamer.png"

import micbackground from "./micbackground.jpeg"
import groupstudent from "./groupstudent.jpeg"
import studentong from "./studentong.png"

import online from "./online.jpg"
import newbg from "./newbg.jpeg"

import diwali from "./diwali.jpeg"
import halloween from "./halloween.jpeg"
import newimage from "./newimage.jpeg"
import header from "./header1.png"
import footer from "./footer1.png"


import newlogin from "./newlogin.png"
import newbg1 from "./newbg1.jpeg"

import newbg2 from "./newbg2.jpeg"

export {newimage,newbg,diwali,halloween,newlogin,newbg1,newbg2
,  groupstudent,
  studentong,
  online,header,footer,
  // cover,
  trophy,
  trophyone,
  micbackground,
  portrait,
  oratricslogo,
  logo,
  reedem,
  revenue,
  service,
  users,
  background,
  hide,
  show,
  dashboard,
  home,
  user,
  showcase,
  settings,
  role,
  market,
  content,
  customer,
  logout,
  demouser,
  remove,
  change,
  see,
  search,
  bright,
  gamer

};
